import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { CapabilityBar } from './components/CapabilityBar';
import { BusinessUnits } from './components/BusinessUnits';
import { NationwideSection } from './components/NationwideSection';
import { PortfolioGrid } from './components/PortfolioGrid';
import { LeadCaptureForm } from './components/LeadCaptureForm';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-bone font-sans selection:bg-gold/30 selection:text-espresso" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <CapabilityBar data-id="element-4" />
        <BusinessUnits data-id="element-5" />
        <NationwideSection data-id="element-6" />
        <PortfolioGrid data-id="element-7" />
        <LeadCaptureForm data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <WhatsAppButton data-id="element-10" />
    </div>;
}